import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateDietExcludedIngredientsDetailsArgs } from '../graphql/transformers'
import { UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS } from '../redux/action-types'

const useUpdateDietExcludedIngredientsDetailsMutation = () => {
  const dispatch = useDispatch()

  const {
    isExcludedIngredientsDetailsLoading,
    excludedIngredientsDetailsError,
  } = useSelector(store => store.diets.diet)

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS_MUTATION,
        {
          id,
          data: transformToUpdateDietExcludedIngredientsDetailsArgs(data),
        },
        dispatch,
        UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    {
      isLoading: isExcludedIngredientsDetailsLoading,
      error: excludedIngredientsDetailsError,
    },
  ]
}

export default useUpdateDietExcludedIngredientsDetailsMutation
